/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Analytics Nav Icon component.
 */
export const SideNavAnalyticsIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);

  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 26 22' fill='none'>
      <rect x='1' y='15.7222' width='3.84' height='5.27778' rx='0.5' stroke={iconColor} strokeWidth='1.5'/>
      <path d='M7.71997 12C7.71997 11.7239 7.94383 11.5 8.21997 11.5H11.06C11.3361 11.5 11.56 11.7239 11.56 12V20.5C11.56 20.7761 11.3361 21 11.06 21H8.21997C7.94383 21 7.71997 20.7761 7.71997 20.5V12Z' stroke={iconColor} strokeWidth='1.5'/>
      <path d='M21.16 8.83333C21.16 8.55719 21.3838 8.33333 21.66 8.33333H24.5C24.7761 8.33333 25 8.55719 25 8.83333V20.5C25 20.7761 24.7761 21 24.5 21H21.66C21.3838 21 21.16 20.7761 21.16 20.5V8.83333Z' stroke={iconColor} strokeWidth='1.5'/>
      <path d='M14.44 14.1111C14.44 13.835 14.6639 13.6111 14.94 13.6111H17.78C18.0561 13.6111 18.28 13.835 18.28 14.1111V20.5C18.28 20.7761 18.0561 21 17.78 21H14.94C14.6639 21 14.44 20.7761 14.44 20.5V14.1111Z' stroke={iconColor} strokeWidth='1.5'/>
      <line x1='3.52892' y1='9.41641' x2='8.20894' y2='5.63863' stroke={iconColor} strokeWidth='1.5'/>
      <line y1='-0.75' x2='4.38205' y2='-0.75' transform='matrix(0.876302 0.481763 -0.413947 0.910301 10.6 6.22223)' stroke={iconColor} strokeWidth='1.5'/>
      <line x1='17.4852' y1='7.45459' x2='21.6052' y2='3.5657' stroke={iconColor} strokeWidth='1.5'/>
      <circle cx='2.5' cy='10.5' r='1.5' stroke={iconColor} strokeWidth='1.5'/>
      <circle cx='9.5' cy='5.5' r='1.5' stroke={iconColor} strokeWidth='1.5'/>
      <circle cx='16.5' cy='8.5' r='1.5' stroke={iconColor} strokeWidth='1.5'/>
      <circle cx='22.5' cy='2.5' r='1.5' stroke={iconColor} strokeWidth='1.5'/>
    </svg>
  );
};

export default SideNavAnalyticsIcon;
